export default __webpack_public_path__ + "sounds/framework/6success_R.13ca07c1.mp3?13ca07c1";